module.exports = __webpack_public_path__ + "img/checkbox.580bf977.svg";